import { Completed } from "../../modules";

const CompletedQuestions = () => {
  return <Completed />;
};

export { CompletedQuestions };
